export default {
    totals: 'Totais',
    grand_total: 'Total Geral',
    work_type: 'Atividades',
    quantity: 'Quantidade',
    total_time: 'Tempo Total',
    call: {
        category: 'Categoria',
        total_ticket: 'Total de Chamados',
        total_worklload: 'Total de Cargas de Trabalho',
        total_time_agreed_load: 'Tempo Total Acordado',
        agreed_load_variation_percent: 'Diferença do Tempo Acordado',
        time_limit_sla: 'Tempo Limite do SLA',
        sla_variation_percent: 'Diferença do SLA'
    },
    task: {
        type: 'Tipo de Tarefa',
        quantity_task: 'Quantidade de Tarefas',
        quantity_items_checklist: 'Quantidade de Itens do Checklist',
        quantity_items_checklist_completed: 'Quantidade de Itens Concluídos',
        total_time_estimated: 'Tempo Total Estimado',
        total_time_workload: 'Tempo Total Cargas de Trabalho',
        workload_variation_percent: 'Precisão do Tempo Estimado'
    }
}
